import React, { Component, useState, useMemo, useEffect } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { AgGridReact } from 'ag-grid-react';
import { toast } from 'react-toastify';
import { useOrderColumns } from './columns';
import { useOrderData } from './data';
import { LicenseManager } from 'ag-grid-enterprise';
import { getLocaleText } from 'utils/localization/agGridLocale';
import { frameworkComponents } from './frameworkComponents';
import LoadingSkeleton from './LoadingSkeleton';
LicenseManager.setLicenseKey(`${AG_GRID_LICENSE}`);
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
const gridOpts = {
    defaultColDef: {
        enableRowGroup: true,
        enablePivot: false,
        sortable: true,
        resizable: true,
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        cellStyle: { 'display': 'flex', 'align-items': 'center' },
    },
    rowDragManaged: true,
    copyHeadersToClipboard: true,
    suppressColumnVirtualisation: true,
    suppressScrollOnNewData: true,
};
const ExploreOrderUnifiedView = () => {
    // Hooks
    const { t } = useTranslation();
    const columns = useOrderColumns();
    const { data: items = [], isLoading, isError, error } = useOrderData();
    useEffect(() => {
        if (isError && error) {
            toast.error(`Error loading orders: ${error.message}`);
        }
    }, [isError, error]);
    // Grid Items
    const getRowNodeId = (data) => data._id;
    const getRowId = (params) => params.data._id;
    const statusBar = { statusPanels: [{ statusPanel: 'agAggregationComponent' }] };
    const getRowHeight = params => 50;
    const onGridReady = (params) => {
        const { api, columnApi } = params;
        api.autoSizeColumns();
        /*
        api.addEventListener('modelUpdated', () => {
          this.handleRowDisplayed();
        });
    
        api.addEventListener('columnVisible', this.onColumnVisible);
        api.addEventListener('filterChanged', this.onFilterChange);
        api.addEventListener('sortChanged', this.onSortChanged);
        api.addEventListener('cellEditingStopped', this.onEditingStopped);
        getFilterResults();
        */
    };
    if (isLoading) {
        return React.createElement(LoadingSkeleton, null);
    }
    return (React.createElement("div", { "data-testid": "", className: "mt-4 px-8 py-4 ag-theme-balham h-[90vh]" },
        React.createElement(AgGridReact, { rowData: items, immutableData: true, maintainColumnOrder: true, rememberGroupStateWhenNewData: true, animateRows: true, getRowHeight: getRowHeight, getRowId: getRowId, suppressClickEdit: true, suppressRowClickSelection: true, enableCellTextSelection: true, enableRangeSelection: true, rowSelection: "multiple", getRowNodeId: getRowNodeId, frameworkComponents: frameworkComponents, multiSortKey: "ctrl", onGridReady: onGridReady, onSortChanged: () => console.log('implement'), statusBar: statusBar, columnDefs: columns, defaultColDef: gridOpts.defaultColDef, onRowSelected: () => console.log('implement'), localeText: getLocaleText(), overlayLoadingTemplate: `<div><span class="text-base text-green font-bold">${t('LOADING')}</span></div>`, sideBar: null, allowDragFromColumnsToolPanel: true })));
};
export default ExploreOrderUnifiedView;
